import * as React from 'react';
import styled from 'styled-components';

export const TableWrapper = styled.div`
  position: relative;
  display: grid;
  grid-template-columns: 447px 1fr;
  padding-bottom: 105px;
`;
